/**
 * Helper para impressão de etiquetas de lotes
 */

import api from '../services/api';
import { showSuccessMessage, showErrorMessage } from '../services/messages';

/**
 * Abre o PDF de etiquetas em uma nova aba para impressão
 * @param {number} batchId - ID do lote
 * @param {number} quantity - Quantidade de etiquetas
 * @returns {Promise<Window>} Janela aberta com o PDF
 */
export const printBatchLabels = async (batchId, quantity = 1) => {
  try {
    // Fazer requisição
    const response = await api.batch.generateLabels(batchId, quantity);
    
    // Criar blob do PDF
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Abrir em nova aba
    const printWindow = window.open(url);
    
    // Limpar URL após abrir
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);
    
    showSuccessMessage(`${quantity} etiqueta(s) gerada(s) com sucesso!`);
    
    return printWindow;
  } catch (error) {
    console.error('Erro ao gerar etiquetas:', error);
    showErrorMessage(error?.response?.data?.error || 'Erro ao gerar etiquetas');
    throw error;
  }
};

/**
 * Faz download do PDF de etiquetas
 * @param {number} batchId - ID do lote
 * @param {number} quantity - Quantidade de etiquetas
 * @returns {Promise<void>}
 */
export const downloadBatchLabels = async (batchId, quantity = 1) => {
  try {
    const response = await api.batch.generateLabels(batchId, quantity);
    
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Criar link temporário para download
    const link = document.createElement('a');
    link.href = url;
    link.download = `etiquetas-lote-${batchId}.pdf`;
    document.body.appendChild(link);
    link.click();
    
    // Limpar
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    
    showSuccessMessage('Download iniciado!');
  } catch (error) {
    console.error('Erro ao baixar etiquetas:', error);
    showErrorMessage('Erro ao baixar etiquetas');
    throw error;
  }
};

export default {
  printBatchLabels,
  downloadBatchLabels,
};

